import React, { useEffect, useRef, useState, useCallback } from 'react';

const InfiniteScroll = ({children, dataLength, next, hasMore, loader}) => {
  const [isLoading, setIsLoading] = useState(false);
  const triggerRef = useRef(null);
  const observerRef = useRef(null);
  const previousDataLength = useRef(dataLength);

  const loadMoreItems = useCallback(() => {
    if (isLoading || !hasMore) return;
    setIsLoading(true);

    Promise.resolve(next())
      .finally(() => {
        setIsLoading(false);
      });
  }, [next, hasMore, isLoading]);


  useEffect(() => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (triggerRef.current && hasMore && !isLoading) {

      const options = {
        root: null,
        rootMargin: '0px 0px 200px 0px',
        threshold: 0.1
      };

      const handleObserver = (entries) => {
        const [entry] = entries;

        if (entry.isIntersecting && !isLoading && hasMore) {
          loadMoreItems();
        }
      };
      observerRef.current = new IntersectionObserver(handleObserver, options);
      observerRef.current.observe(triggerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [hasMore, isLoading, loadMoreItems]);

  useEffect(() => {
    if (dataLength !== previousDataLength.current) {
      previousDataLength.current = dataLength;
      setTimeout(() => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const isContentShort = documentHeight < windowHeight * 1.2;

        if (isContentShort && hasMore && !isLoading) {
          loadMoreItems();
        }
      }, 300);
    }
  }, [dataLength, hasMore, isLoading, loadMoreItems]);

  return (
    <div className="infinite-scroll-component">
      {children}
      <div
        ref={triggerRef}
        style={{
          height: '20px',
          margin: '10px 0',
          visibility: hasMore ? 'visible' : 'hidden'
        }}
      />
    </div>
  );
};

export default InfiniteScroll;